export const testimonials = [
  {
    quote: {
      en: 'Professional, reliable, and high-quality work. Highly recommend!',
      es: '¡Trabajo profesional, confiable y de alta calidad. Altamente recomendado!',
    },
    author: 'Michael Johnson',
    location: 'Chicago',
  },
  {
    quote: {
      en: 'The team showed up on time, stayed within budget, and did excellent work. Will definitely use them again.',
      es: 'El equipo llegó a tiempo, se mantuvo dentro del presupuesto e hizo un trabajo excelente. Definitivamente los usaremos de nuevo.',
    },
    author: 'Sarah Martinez',
    location: 'Oak Park',
  },
  {
    quote: {
      en: "Best concrete contractor we've worked with. Great communication and amazing results.",
      es: 'El mejor contratista de concreto con el que hemos trabajado. Gran comunicación y resultados increíbles.',
    },
    author: 'Robert Chen',
    location: 'Evanston',
  },
  {
    quote: {
      en: 'Exceeded all expectations. Professional crew, on budget, excellent finish.',
      es: 'Superaron todas nuestras expectativas. Equipo profesional, dentro del presupuesto, acabado excelente.',
    },
    author: 'Lisa Anderson',
    location: 'Cicero',
  },
];
